import React from 'react';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { array, func } from 'prop-types';
import StackedToast from './StackedToast';

function StackedToasts({ messages, setMessages }) {
    const handleClose = (id) => {
        setMessages(messages.filter((message) => message.id !== id));
    };
    return (
        <ToastContainer
            className={'p-3 position-fixed custom-toast-container'}
            position={'top-end'}
            style={{
                zIndex: 10002,
            }}>
            {messages.map((message) => (<StackedToast
                key={message.id}
                id={message.id}
                text={message.text}
                isoTime={message.isoTime}
                bg={message.bg}
                onClose={handleClose} />))}
        </ToastContainer>
    );
}

StackedToasts.propTypes = {
    setMessages: func,
    messages: array,
};

export default StackedToasts;